import Users from "../pages/Users";
import Login from "../pages/Login";
import Dashboard from "../pages/Dashboard";
import Profile from "../pages/Profile";
import EditProfile from "../pages/EditProfile";
import ChangePassword from "../pages/ChangePassword";
import ForgotPassword from "../pages/ForgotPassword";
import Groups from "../pages/Groups";
import UserReport from "../pages/UserReport";
import Notifications from "../pages/Notifications";
import Subscriptions from "../pages/Subscriptions";
import VerificationRequest from "../pages/VerificationRequest";
import Verifications from "../pages/Verifications";
import NewDashboard from "../pages/NewDashboard";
import UserDescription from "../pages/UserDescription";
import GroupMember from "../pages/GroupMember";
import UserReportMember from "../pages/UserReportMember";
import GroupReport from "../pages/GroupReport";
import GroupReportMember from "../pages/GroupReportMember";
import NotificationDetail from "../pages/NotificationDetail";
import InstagramConnect from "../pages/Instagram";
import Support from "../pages/Support";

export const pageRoutes = {
  // dashboard: "/",
  newDashBoard: "/",
  login: "/login",
  profile: "/profile",
  editProfile: "/edit-profile",
  changePassword: "/change-password",
  forgotPassword: "/forgot-password",
  users: "/users",
  userDescription: "/user-description",
  groups: "/groups",
  groupMember: "/group-member",
  userReport: "/user-report",
  GroupReport: "/group-report",
  userReportMember: "/user-report-member",
  notifications: "/notifications",
  subscriptions: "/subscriptions",
  verifications: "/verifications",
  verificationRequest: "/verification-request",
  InstagramConnect: "/ig-callback",
  GroupReportMember: "/Group-Report-Member",
  notificationDetail: "/notification-detail",
Support: "/support",
};

export const AllRoutes = [
  // {
  //     name: "Dashboard",
  //     path: pageRoutes.dashboard,
  //     element: <Dashboard />,
  //     isPrivate: true,
  // },
  {
    name: "NotificationDetail",
    path: pageRoutes.notificationDetail,
    element: <NotificationDetail />,
    isPrivate: true,
  },
  {
    name: "newDashBoard",
    path: pageRoutes.newDashBoard,
    element: <NewDashboard />,
    isPrivate: true,
  },
  {
    name: "Login",
    path: pageRoutes.login,
    element: <Login />,
    isPrivate: false,
  },
  {
    name: "Profile",
    path: pageRoutes.profile,
    element: <Profile />,
    isPrivate: true,
  },
  {
    name: "EditProfile",
    path: pageRoutes.editProfile,
    element: <EditProfile />,
    isPrivate: true,
  },
  {
    name: "ChangePassword",
    path: pageRoutes.changePassword,
    element: <ChangePassword />,
    isPrivate: true,
  },
  {
    name: "ForgotPassword",
    path: pageRoutes.forgotPassword,
    element: <ForgotPassword />,
    isPrivate: false,
  },
  {
    name: "Users",
    path: pageRoutes.users,
    element: <Users />,
    isPrivate: true,
  },
  {
    name: "userDescription",
    path: pageRoutes.userDescription,
    element: <UserDescription />,
    isPrivate: true,
  },
  {
    name: "Groups",
    path: pageRoutes.groups,
    element: <Groups />,
    isPrivate: true,
  },
  {
    name: "groupMember",
    path: pageRoutes.groupMember,
    element: <GroupMember />,
    isPrivate: true,
  },
  {
    name: "UserReport",
    path: pageRoutes.userReport,
    element: <UserReport />,
    isPrivate: true,
  },
  {
    name: "GroupReport",
    path: pageRoutes.GroupReport,
    element: <GroupReport />,
    isPrivate: true,
  },
  {
    name: "GroupReportMember",
    path: pageRoutes.GroupReportMember,
    element: <GroupReportMember />,
    isPrivate: true,
  },
  {
    name: "UserReportMember",
    path: pageRoutes.userReportMember,
    element: <UserReportMember />,
    isPrivate: true,
  },
  {
    name: "Notifications",
    path: pageRoutes.notifications,
    element: <Notifications />,
    isPrivate: true,
  },
  {
    name: "Subscriptions",
    path: pageRoutes.subscriptions,
    element: <Subscriptions />,
    isPrivate: true,
  },
  {
    name: "Verifications",
    path: pageRoutes.verifications,
    element: <Verifications />,
    isPrivate: true,
  },
  {
    name: "VerificationRequest",
    path: pageRoutes.verificationRequest,
    element: <VerificationRequest />,
    isPrivate: true,
  },
  {
    name: "InstagramConnect",
    path: pageRoutes.InstagramConnect,
    element: <InstagramConnect />,
    isPrivate: false,
  },
  {
    name: "Support",
    path: pageRoutes.Support,
    element: <Support />,
    isPrivate: false,
  },
];
